export * from './delete-kunden-gruppe-request.interface';
export * from './delete-kunden-gruppe-response.interface';
export * from './delete-kunden-gruppe.shapes';
